/**
 * This button is used to enter a niche on the My Niches page.
 */

import { Link } from "react-router-dom";

import "./buttons.scss";

import { ReactComponent as Icon } from "../icons/right_arrow.svg";

export const EnterButton = (props: {
  link: string;
}): JSX.Element => {
  return (
    <Link className="enter rg-button" to={props.link}>
      <Icon />
    </Link>
  );
};
